if (!customElements.get('blog-filter')) {
  class BlogFilter extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('.blog-filter__more');
      this.search = this.querySelector('.blog-filter__search');
      this.items = Array.from(this.querySelectorAll('.blog-filter__all-item'));
      this.empty = this.querySelector('.blog-filter__empty');

      if (this.search) {
        this.search.addEventListener('input', () => this.filter());
      }

      if (this.details) {
        // Beim Aufklappen das Suchfeld fokussieren
        this.details.addEventListener('toggle', () => {
          if (this.details.open && this.search) this.search.focus();
        });
        // Klick ausserhalb schliesst das Panel
        document.addEventListener('click', (evt) => {
          if (this.details.open && !this.details.contains(evt.target)) {
            this.details.open = false;
          }
        });
        // Escape schliesst das Panel
        this.addEventListener('keydown', (evt) => {
          if (evt.key === 'Escape' && this.details.open) {
            this.details.open = false;
            this.details.querySelector('summary').focus();
          }
        });
      }
    }

    filter() {
      const query = this.search.value.trim().toLowerCase();
      let visible = 0;
      this.items.forEach((item) => {
        const match = query === '' || item.dataset.name.indexOf(query) !== -1;
        item.hidden = !match;
        if (match) visible += 1;
      });
      if (this.empty) this.empty.hidden = visible !== 0;
    }
  }

  customElements.define('blog-filter', BlogFilter);
}
